import React, { createContext, PropsWithChildren, ReactNode, useContext, useMemo } from 'react';
import * as portals from 'react-reverse-portal';

type GlobalBannerContextValue = {
  bannerPortalNode?: portals.HtmlPortalNode;
};

const GlobalBannerContext = createContext<GlobalBannerContextValue>({});

export function GlobalBannerContextProvider({
  children,
  banner,
}: PropsWithChildren<{ banner: ReactNode }>) {
  const bannerPortalNode = useMemo(() => portals.createHtmlPortalNode(), []);

  return (
    <GlobalBannerContext.Provider
      value={{ bannerPortalNode: banner ? bannerPortalNode : undefined }}
    >
      <portals.InPortal node={bannerPortalNode}>{banner}</portals.InPortal>
      {children}
    </GlobalBannerContext.Provider>
  );
}

export function useGlobalBannerContext() {
  return useContext(GlobalBannerContext);
}
